export const SEARCH_DEBOUNCE_DELAY = 500;
export const SAVE_DEBOUNCE_DELAY = 1000;
